import React from 'react'
import styled from 'styled-components'
import AddBoxIcon from '@mui/icons-material/AddBox';
import ClearIcon from '@mui/icons-material/Clear';
import RefreshIcon from '@mui/icons-material/Refresh';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

import { createTheme, ThemeProvider } from '@mui/material/styles';

import { useParams } from 'react-router-dom'

import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone.js';
import utc from 'dayjs/plugin/utc.js';
dayjs.extend(utc);
dayjs.extend(timezone);

const ModalBox = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 80vw;
  height: 80vh;
  background: white;
  border: 2px solid #000;
  box-shadow: 24px;
  padding-left: 1vw;
  padding-right: 1vw;

  padding-top: 1vh;
  padding-bottom: 1vh;

  display: flex;
  flex-direction: column;
`

const ModalTitleBox = styled.div`
  font-size: 2rem;
  display: flex;
  justify-content: space-between;
`

const ModalBody = styled.div`
  
`
const WorkersTitle = styled.div`
  font-size: 2rem;

  display: flex;

  align-items: center;
  justify-content: space-between;
`

const WorkersBanner = styled.div`
  display: grid;
  grid-template-columns: repeat(4, minmax(100px, 1fr));
  grid-auto-rows: 50px;
  gap: 10px;
  overflow: auto;
  padding-bottom: 20px;

  height: 25vh;

  &.AVAILABLE {
  }
`

const WorkerBox = styled.div`
  border: 1px solid darkgrey;
  border-radius: 5px;

  font-size: 1.5rem;

  display: flex;
  justify-content: space-between;
  align-items: center;

  padding-left: 1vw;
  padding-right: 1vw;
`

const WorkerAddRemoveButtonBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  cursor: pointer;
`

const SaveBox = styled.div`
  display: flex;
`

const SaveButton = styled.button`
  width: 130px;

  border: 2px solid tomato;
  border-radius: 3px;
  background: white;
  font-weight: bold;
  color: tomato;

  margin-top: 1vh;

  &:hover{
    background: tomato;
    color: white;
  }

  padding: 10px 0vw 10px 0vw;

  font-size: 1.2rem;
`

const CancelButton = styled.button`
  width: 130px;

  border: 2px solid darkgrey;
  border-radius: 3px;
  background: white;
  font-weight: bold;
  color: darkgrey;

  margin-top: 1vh;

  &:hover{
    background: #F8F8F8;
  }

  margin-left: 5px;
  padding: 10px 0vw 10px 0vw;
  font-size: 1.2rem;
`

const ErrorMessageBox = styled.div`
  color: #e1341e;
  font-weight: bold;
  margin-top: 1vh;

  &.SUCCESS {
    color: #31b76b;
  }
`

const theme = createTheme({
  palette: {
    primary: {
      main: '#FF6347',
    },
  },
});

export default function AllocationAllocateModal({ data, updatePage, closeModal }) {
  const [shift, setShift] = React.useState(data);
  const { JobId } = useParams()
  const [workers, setWorkers] = React.useState([]);
  const [available, setAvailable] = React.useState([]);

  const [workersChanged, setWorkersChanged] = React.useState([])
  const [availChanged, setAvailChanged] = React.useState([])


  const [errorMsg, setErrorMsg] = React.useState("")
  const handleAddWorker = (targetId) => {
    if (workersChanged.length < shift.numWorkers) {
      setAvailChanged(currentAvailable => currentAvailable.filter(worker => worker.worker_id !== targetId));
      setWorkersChanged([...workersChanged, { worker_id: targetId }])
    }

  }

  const handleRemoveWorker = (targetId) => {
    setWorkersChanged(currentWorkers => currentWorkers.filter(worker => worker.worker_id !== targetId));
    setAvailChanged([...availChanged, { worker_id: targetId }])
  }

  const handleSaveChanges = async () => {
    const addedToListA = workersChanged.filter(workerChanged =>
      !workers.some(worker => worker.worker_id === workerChanged.worker_id));

    const removedFromListA = workers.filter(worker =>
      !workersChanged.some(workerChanged => workerChanged.worker_id === worker.worker_id));

    const changes = {
      jobId: JobId,
      shiftId: shift.shift_id,
      allocated: addedToListA,
      removed: removedFromListA
    }

    try {
      const res = await fetch(`/api/allocations/updateShiftWorkers`, {
        method: "POST",
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(changes)
      });

      const data = await res.json()
      if (data.error) {
        setErrorMsg(data.error)
        throw new Error("Could not update shift workers")
      }

      setErrorMsg(data.message)
      updatePage()
    } catch (error) {
      console.error("error:", error)
    }
  }

  // -- Getting workers assigned to shift
  const getShiftWorkers = async () => {
    try {
      const res = await fetch(`/api/allocations/jobs/${JobId}/shift/${shift.shift_id}/workers`)

      const data = await res.json()

      setWorkers(data)
      setWorkersChanged(data)

    } catch (error) {
      alert("Error getting shift workers")
    }
  }

  // -- Getting workers available

  const getAvailableWorkers = async () => {
    try {
      const res = await fetch(`/api/allocations/jobs/${JobId}/shift/${shift.shift_id}/workers/available`)

      const data = await res.json()
      // alert(JSON.stringify(data))

      setAvailable(data)
      setAvailChanged(data)
    } catch (error) {
      alert("Error getting available workers")
    }
  }

  React.useEffect(() => {
    getShiftWorkers();
    getAvailableWorkers();
  }, [])

  return (
    <ThemeProvider theme={theme}>
      <ModalBox>
        <ModalTitleBox>
          <div>
            {dayjs(shift.date).tz('Australia/Sydney').format('DD/MM/YYYY')} | {dayjs(shift.startTime).tz('Australia/Sydney').format('h:mm a')} - {dayjs(shift.endTime).tz('Australia/Sydney').format('h:mm a')}
          </div>
          <div>
            <IconButton onClick={() => { getAvailableWorkers() }}>
              <RefreshIcon sx={{ fontSize: "2rem", color: "tomato" }} />
            </IconButton>
            <IconButton onClick={() => { closeModal() }}>
              <CloseIcon sx={{ fontSize: "2rem", color: "tomato" }} />
            </IconButton>
          </div>
        </ModalTitleBox>
        <ModalBody>
          <WorkersTitle>
            <div>
              Assigned Workers: {workersChanged.length}/{shift.numWorkers}
            </div>

          </WorkersTitle>
          <WorkersBanner >
            {workersChanged.map((worker, idx) => (
              <WorkerBox>
                id: {worker.worker_id}
                <WorkerAddRemoveButtonBox onClick={() => { handleRemoveWorker(worker.worker_id) }}>
                  <ClearIcon sx={{ fontSize: "2rem", "color": "darkgrey" }} />
                </WorkerAddRemoveButtonBox>
              </WorkerBox>
            ))}
          </WorkersBanner>
          <WorkersTitle>
            Available
          </WorkersTitle>
          <WorkersBanner className="AVAILABLE">
            {availChanged.map((worker, idx) => (
              <WorkerBox>
                id: {worker.worker_id}
                <WorkerAddRemoveButtonBox onClick={() => { handleAddWorker(worker.worker_id) }}>
                  <AddBoxIcon sx={{ fontSize: "2rem", "color": "tomato" }} />
                </WorkerAddRemoveButtonBox>
              </WorkerBox>
            ))}
          </WorkersBanner>
        </ModalBody>

        <SaveBox>
          <SaveButton onClick={() => handleSaveChanges()}>Save</SaveButton>
          <CancelButton onClick={() => { closeModal() }}>Cancel</CancelButton>
        </SaveBox>
        {
          errorMsg === "Successfully updated shift workers" ?
            <ErrorMessageBox className="SUCCESS">{errorMsg} </ErrorMessageBox>
            :
            <ErrorMessageBox >{errorMsg} </ErrorMessageBox>
        }
      </ModalBox>
    </ThemeProvider>
  )
}
